import { OrganizationType } from "../../enums";
import { ORGANIZATION_COUNTRY_MAP, OrganizationCountry } from "../enums/country";
export const isOnboardingAllowedForCountry = (country, environments) => {
    if (!country) {
        return false;
    }
    return getAllowedOrganizationCountries(environments).includes(country);
};
export const getAllowedOrganizationCountries = (_environments) => {
    const countries = [
        OrganizationCountry.Canada,
        OrganizationCountry.UnitedStates,
        OrganizationCountry.GreatBritain,
        OrganizationCountry.Australia,
        OrganizationCountry.Ireland,
        OrganizationCountry.Germany,
    ];
    return countries.sort((a, b) => ORGANIZATION_COUNTRY_MAP[a].countryName.localeCompare(ORGANIZATION_COUNTRY_MAP[b].countryName));
};
export const getOrganizationTypeRadioValues = (country, displayedValues) => {
    if (country === OrganizationCountry.Canada) {
        return {
            [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
            [OrganizationType.Social]: displayedValues[OrganizationType.Social],
            [OrganizationType.Private]: displayedValues[OrganizationType.Private],
        };
    }
    if (country === OrganizationCountry.GreatBritain) {
        return {
            [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
            [OrganizationType.Other]: displayedValues[OrganizationType.Other],
            [OrganizationType.Private]: displayedValues[OrganizationType.Private],
        };
    }
    if (country === OrganizationCountry.Ireland) {
        return {
            [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
        };
    }
    if (country === OrganizationCountry.Germany) {
        return {
            [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
            [OrganizationType.Other]: displayedValues[OrganizationType.Other],
            [OrganizationType.Private]: displayedValues[OrganizationType.Private],
        };
    }
    if (country === OrganizationCountry.Australia) {
        return {
            [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
            [OrganizationType.Other]: displayedValues[OrganizationType.Other],
            [OrganizationType.Private]: displayedValues[OrganizationType.Private],
        };
    }
    if (country === OrganizationCountry.UnitedStates) {
        return {
            [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
            [OrganizationType.Other501C]: displayedValues[OrganizationType.Other501C],
            [OrganizationType.Other]: displayedValues[OrganizationType.Other],
            [OrganizationType.Private]: displayedValues[OrganizationType.Private],
        };
    }
    return {
        [OrganizationType.Charity]: displayedValues[OrganizationType.Charity],
        [OrganizationType.Other]: displayedValues[OrganizationType.Other],
        [OrganizationType.Private]: displayedValues[OrganizationType.Private],
    };
};
export const isSocialSecurityNumberAsked = (country) => {
    return country === OrganizationCountry.UnitedStates;
};
export const isAutomaticOnboardingSupported = (country) => {
    return country === OrganizationCountry.Canada || country === OrganizationCountry.UnitedStates;
};
